export default {
  list: {
    py: 3,
    px: 1.5,
  },
  listItemButton: {
    p: 1,
    alignItems: 'center',
    '&.Mui-selected': {
      backgroundColor: 'text.grey.blue_1',
      borderRadius: 42,
      '& .MuiListItemText-root, .MuiListItemIcon-root': {
        color: 'text.white',
      },
    },
  },
  listItemIcon: {
    minWidth: 24,
    height: 24,
    color: 'text.grey.blue_2',
    px: 1,
  },
  text: {
    color: 'text.grey.blue_2',
    '& .MuiTypography-root': {
      typography: 'body2',
    },
  },
};
